import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { LargeBusiness } from '../../Constants';

function CarouselTextContent({ textContent, isAlignCenter}) {

  // Font-color
  const useStyle = makeStyles({
    root: {
      "& h1": {
        textAlign: isAlignCenter ? "center" : "left",
        color: textContent.titleColor + " !important",
      }, 
      "& h2": {
        textAlign: isAlignCenter ? "center" : "left",
        color: textContent.titleColor + " !important",
      },
      "& p": {
        textAlign: isAlignCenter ? "center" : "left",
        color: textContent.descriptionColor + " !important",
      },
    },
  });
  const classes = useStyle();
  return (
    <div
      className={"carousel-description-text " + (LargeBusiness?"LB ":"") + classes.root}
      // dangerouslySetInnerHTML={{ __html: textContent }}
    >
      { textContent.contentText.map((title, key) => <Title title={title} useH1={textContent.useH1} key={key}/>)  } 
      
      <p className={`carousel-description-text-subtitle eir-subtitle3 ${!isAlignCenter? "subtitle-width" : ""}`} dangerouslySetInnerHTML={{ __html: textContent.contentDescription }} />
    </div>
  );
}
// H1==H2
const Title = ({ title, useH1 }) => {
  return useH1 ? 
  <h1 className="carousel-description-text-title" dangerouslySetInnerHTML={{ __html: title }} /> 
  : <h2 className="carousel-description-text-title" dangerouslySetInnerHTML={{ __html: title }}  />;
};
export default CarouselTextContent;
